module.exports = __webpack_public_path__ + "media/images/pc/items/gift/kiribako_01-1c3482c16f9d30ca7e7ebc964ccd08d2.jpg";